<template>
  <div class="load-hide" >
    <!--<topbar></topbar>-->
    <div class="recharge_types setup" style="padding: 0.125rem 0.19rem 0; ">
      <div>
        <mt-datetime-picker
          ref="picker"
          type="date"
          :startDate="startDate"
          :endDate ="endDate"
          v-model="pickerValue" @confirm="dealentity">
        </mt-datetime-picker>
      </div>
      <table style="white-space: nowrap" class="table table-bordered table-condensed dataTables-example dataTable no-footer">
        <tbody>
        <tr>
          <td class="width-35"><label style="color: #252525;">UID</label></td>
          <td class="td_bottom">{{cardMember.uid}}</td>
        </tr>
        <tr>
          <td class="width-35"><label style="color: #252525;">卡号</label></td>
          <td v-model="card_num" class="td_bottom">{{card.card_num}}</td>
        </tr>
        <tr>
          <td class="width-35"><label style="color: #252525;">姓名</label></td>
          <td v-model="cust_name" @click="editN" class="td_bottom">{{card.cust_name}}</td>
        </tr>
        <tr>
          <td class="width-35"><label style="color: #252525;">手机</label></td>
          <td v-model="cust_mobile"  class="td_bottom">{{card.cust_mobile}}</td>
        </tr>
        <tr>
          <td class="width-35"><label style="color: #252525;">性别</label></td>
          <td v-model="cust_gender" @click="editG" class="td_bottom">{{getGender[card.cust_gender]}}</td>
        </tr>
        <tr>
          <td class="width-35"><label style="color: #252525;">生日</label></td>
          <td @click="openPicker" v-if="card.cust_birthday" v-model="cust_birthday"  class="td_bottom tb_birth">
            {{card.cust_birthday | date('%Y-%m-%d')}}
            <!--<input v-model="newBirthday" type="date" class="dps" @blur="dealentity()">-->
          </td>
          <td v-else></td>
        </tr>
        </tbody>
      </table>
      <div class="unbind_input"><input type="button" value="解绑" @click="unBind"></div>
      <!--<div class="unbind_back"><input type="button" value="返回" @click="gobackCardQrcode"></div>-->
    </div>
    <div class="out-all" style="display:none;">
      <div class="include-black"></div>
      <div class="include-text">
        <p>确认解绑电子卡？</p>
        <!--<p>解绑之后，您将无法使用电子卡进行支付</p>-->
        <div>
          <input type="button"  value="取消" class="choose-no" @click="closeQ">
          <input type="button" value="确认" class="choose-yes" @click="unBindOk">
        </div>
      </div>
    </div>
    <div class="out-alln" style="display:none;">
      <div class="include-black"></div>
      <div class="include-text">
        <p>请填入您的姓名</p>
        <div class="inContext"><input type="text" v-model="newName" class="nps"></div>
        <div>
          <input type="button"  value="取消" class="choose-no" @click="closeQ">
          <input type="button" value="确认" class="choose-yes" @click="dealentity">
        </div>
      </div>
    </div>
    <div class="out-allg" style="display:none;">
      <div class="include-black"></div>
      <div class="include-text">
        <p style="color:#000">请选择性别</p>
        <div class="inContext" style="margin: 0.1rem 0 !important;">
          <div class="ch_what"><input :class="{green_choosed:isWhatGender=='N'}" @click="ch_none" value="保密" type="button"></div>
          <div class="ch_what"><input :class="{green_choosed:isWhatGender=='M'}" @click="ch_b" value="男" type="button"></div>
          <div class="ch_what"><input :class="{green_choosed:isWhatGender=='G'}" @click="ch_g" value="女" type="button"></div>
          <!--<select style="width: 70%;" v-model="newGender" class="gps">-->
            <!--<option value="N">保密</option>-->
            <!--<option value="M">男</option>-->
            <!--<option value="G">女</option>-->
          <!--</select>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        cardMember:{},
        card:{},
        getGender:{
            "N":"保密",
            "M":"男",
            "G":"女"
        },
        mid:'',
        card_num:'',
        cust_name:'',
        cust_mobile:'',
        cust_gender:'',
        cust_birthday:'',

        newName:'',
        newPhone:'',
        newGender:'',
        newBirthday:'',

        isWhatGender:'',

        pickerValue:'',
        startDate:new Date("1970-01-01"),
        endDate:new Date()
      }
  },
  mounted(){
    this.refresh();
  },
  methods: {
    openPicker() {
      this.$refs.picker.open();
    },
    ch_none(){
      this.isWhatGender = 'N'
      this.dealentity()
    },
    ch_b(){
      this.isWhatGender = 'M'
      this.dealentity()
    },
    ch_g(){
      this.isWhatGender = 'G'
      this.dealentity()
    },
    editN(){
      $(".out-alln").show();
      this.newName = this.card.cust_name;
    },
    editG(){
      $(".out-allg").show();
      this.newGender = this.card.cust_gender;
    },
    editB(cbs){
      var cbs = new Date(this.card.cust_birthday);
      var year = cbs.getFullYear();
      var month = cbs.getMonth()+1;
      if(month<= 9 & month>0){
        month = '0'+month
      }
      var day = cbs.getDate();
      if(day<=9 & day>0){
        day = '0'+day
      }
      var nowDate = year+'-'+month+'-'+day;
      console.log(nowDate,233);
      this.newBirthday = nowDate;
    },
    dealentity(){
      this.cust_name = this.newName;
      this.cust_gender = this.isWhatGender;
      var cb = this.pickerValue;
      console.log(cb,11);
      this.cust_birthday = new Date(cb).getTime();
      console.log(this.cust_birthday,22);
      this.editMessage();
    },
    refresh(){
      this.$http.post(constants.API_HOST + constants.API_VIEW_CARD, {
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
          console.log(data.data);
          this.cardMember = data.data.cardMember;
          this.mid = data.data.cardMember.mid;
          this.card = data.data.card;
          this.editB(this.card.cust_birthday);
        }else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    },
    editMessage(){
      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
//      if(this.cust_mobile && !numREG.test(this.cust_mobile)){
//          this.$alert("请输入正确的手机号!")
//      }
//      if(!this.cust_name || !this.cust_gender || !this.cust_birthday){
//        this.$alert("请输入正确的信息!")
//      }else{

        this.$http.post(constants.API_HOST + constants.API_CARD_MODIFY, {
          mid:this.mid,
          cust_name:this.cust_name,
          cust_mobile:this.cust_mobile,
          cust_gender:this.cust_gender,
          cust_birthday:this.cust_birthday
        }).then((result) => {
          let data = result.data;
          if (data.code === "200") {
            location.reload()
          }else {
            this.$alert(data.data);
          }
        }, (error) => {
          error.data && this.$alert(error.data);
        });
//      }
    },
    unBind(){
      $(".out-all").show();
    },
    gobackCardQrcode(){
        router.push('card_qrcode')
    },
    closeQ(){
      $(".out-all").hide();
      $(".out-alln").hide();
      $(".out-allg").hide();
      $(".out-allb").hide();
    },
    unBindOk(){
      this.$http.post(constants.API_HOST + constants.API_UNBIND_CARD, {
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
          router.push('card_choose')
        } else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    }
  }

}

</script>

<style>
  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .out-all,.out-alln,.out-allp,.out-allg,.out-allb{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    font-size:0.15rem;
  }
  .include-black{
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.8;
    width: 100%;
    height: 100%;
  }
  .include-text{
    background: #fff;
    width: 80%;
    /*height: 1.2rem;*/
    z-index: 3;
    position: absolute;
    text-align: center;
    top: 1.6rem;
    border-radius: 0.05rem;
    margin: 0 10%;
  }

  .include-text p{
    margin: 0.2rem 0 0.1rem;
    font-size: 0.14rem;
  }
  .include-text div{
    margin: 0.2rem 0;
  }
  .include-text img{
    width: 200px;
  }

  .include-text input{
    border: 0px;
    background: #3d9946;
    color: #FFF;
    width: 0.875rem;
    height: 0.235rem;
    border-radius: 0.01rem;
    font-size:0.13rem
  }
  .inContext input{
    background: #fff;
    border:1px solid #e8e8e8;
    border-radius: 0;
    width:70%;
    color:inherit;
    box-shadow: none;
  }
  .choose-no{
    background: #F0F3F6 !important;
    color:#000 !important;
    border:1px solid #bec0c2 !important;
  }
  .recharge_types{
    background: #fff;
    min-height: 100%;
  }
  .recharge_types.setup{
    background: #eff3f6;
  }
  .td_bottom{
    text-align: right;
    color:#9e9e9e
  }
  .setup input{
    border: 0;
    padding: 5px;

  }
  .setup table,.setup tbody,.setup tr,.setup td{
    vertical-align: middle !important;
    border:0 !important;
    font-size:16px;
  }
  .setup tr{
    border-bottom: 1px solid #e8e8e8 !important;
  }
  .unbind_back{
    width:100%;
    position: fixed;
    left: 0;
    bottom: 3%;
    padding: 0 0.15rem;
  }
  .unbind_back input{
    width: 100%;
    height: 0.35rem;
    border: 0;
    background: #fff;
    border-radius: 0.05rem;
    color: #50a200;
    font-size: 0.14rem;
  }
  .unbind_input{
    width:100%;
    position: fixed;
    left: 0;
    bottom: 3%;
    padding: 0 0.15rem;
  }
  .unbind_input input{
    width: 100%;
    height: 0.35rem;
    border: 0;
    background: #f8f8f8;
    border-radius: 0.05rem;
    color: #000000;
    font-size: 0.14rem;
    border:1px solid #bec0c2;
  }
  td .dps{
    background:#fff;
    border:1px solid #e1e1e1;
    width: 35%;
    height:0.15rem;
    -webkit-appearance: none;
    width: 70%;
    height: 20%;
    font-size:0.13rem ;
  }
  .tb_birth{
    padding: 8px 0 !important;
  }
  .gps{
    background:#fff;
    border:1px solid #e1e1e1;
    width: 35%;
    -webkit-appearance: none;
  }
  .nps{
    -webkit-appearance: none;
  }
  .ch_what{
    width: 100%;
    background: #fff;
    margin: 0 !important;
  }
  .ch_what input{
    color: #449a4f;
    width: 90%;
    height: 0.45rem;
    font-size: 0.14rem;
    background: #f8f8f8;
    text-align: center;
    outline: none;
    border: 1px solid #e8e8e8;
    margin: 8px;
  }
  .ch_what .green_choosed{
    border: 1px solid #47994d;
  }
</style>



// WEBPACK FOOTER //
// setup.vue?4aa9abfb